module.exports = __webpack_public_path__ + "static/media/healthcare.8e84ba90.png";